import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import Util from 'app/scripts/lib/util/index.coffee';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';

import { forTemplate } from 'app/common/lib/util/i18n';

const format = forTemplate('advanced_checklists');

interface Options {
  title: string;
  clear: () => void;
}

export function toggleClearPopover({ title, clear }: Options) {
  return function toggle(e: MouseEvent) {
    Util.stop(e);

    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => title,
      keepEdits: true,
      reactElement: (
        <PopoverMenu key={'clear'}>
          <PopoverMenuButton
            onClick={() => {
              PopOver.hide();
              clear.call(this);
            }}
          >
            {format('clear')}
          </PopoverMenuButton>
        </PopoverMenu>
      ),
    });
  };
}
